var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('button',{staticClass:"btn btn-info",staticStyle:{"height":"20px","line-height":"0.5","width":"30px"},on:{"click":function($event){$event.stopPropagation();return _vm.invokeParentMethod.apply(null, arguments)}}},[_vm._v("+")])])}
var staticRenderFns = []

export { render, staticRenderFns }